// Core
import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { 
  Box, 
  Button, 
  Flex, 
  Text, 
  Grid, 
  Divider, 
  Image,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Textarea
} from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';
import glow from 'assets/img/glow-9.png';

// Components
import { StarsIcon } from 'components/Icons/Icons';
import ErrorCard from 'components/Form/Errors';
import SuccessCard from 'components/Form/Success';

const SupportForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [issue, setIssue] = useState('');
  const [message, setMessage] = useState('');

  const [errorCard, setErrorCard] = useState();
  const [successCard, setSuccessCard] = useState();

  const [isValidInputName, setIsValidInputName] = useState(true);  
  const [isValidInputEmail, setIsValidInputEmail] = useState(true); 
  const [isValidInputIssue, setIsValidInputIssue] = useState(true);   
  const [isValidInputMessage, setIsValidInputMessage] = useState(true);  

  const [disabledButton, setDisabledButton] = useState(true);  
  const [isLoadingButton, setIsLoadingButton] = useState(false);  

  const handleNameChange = (event) => {
    setIsValidInputName(true);
    const value = event.target.value;
    setName(value);
    setIsValidInputName(value.length > 0 ? true : false);

    setErrorCard();
    setSuccessCard();
  };

  const handleEmailChange = (event) => {
    setIsValidInputEmail(true);
    const value = event.target.value;
    setEmail(value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidInputEmail(emailRegex.test(value));

    setErrorCard();
    setSuccessCard();
  };

  const handleIssueChange = (event) => {
    setIsValidInputIssue(true);
    const value = event.target.value;
    setIssue(value);
    setIsValidInputIssue(value.length > 0 ? true : false);

    setErrorCard();
    setSuccessCard();
  };

  const handleMessageChange = (event) => {
    setIsValidInputMessage(true);
    const value = event.target.value;
    setMessage(value);
    setIsValidInputMessage(value.length > 0 ? true : false);

    setErrorCard();
    setSuccessCard();
  };

  useEffect(() => {
    if (name && email && issue && message 
      && isValidInputName && isValidInputEmail && isValidInputIssue && isValidInputMessage) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [name, email, issue, message]);

  const handleSend = async () => {
    setIsLoadingButton(true);

    try {
      const data = { name, email, issue, message };

      const response = await apiService.sendEmail(data);
      if(response.data === false || response.statusCode !== 200){
        setErrorCard(response.message);
        setIsLoadingButton(false);
        return;
      }

    } catch(e){
      setErrorCard(true);
      setIsLoadingButton(false);
      return;
    }

    setName('');
    setEmail('');
    setIssue('');
    setMessage('');
    setDisabledButton(true);
    setIsLoadingButton(false);

    setSuccessCard('Message sent successfully');
  };

  return (
  	<Grid mt="18px" alignItems="center" templateColumns={{ sm: '1fr', md: '0.8fr 1fr' }} gap="10px" templateRows='1fr'>
      <Box maxW={{base: '100%', md: '471px'}}>
        <Flex mt="30px" gap="8px" position="relative" alignItems="center">
          <Text variant="header" 
            fontSize={{base: '32px', sm: '36px'}} w={{base: 'unset', sm: 'max-content'}}>
            Contact Support
          </Text>
          <StarsIcon fontSize="16px" />
          <Box className="abstract-grad" transform="scale(0.6)" mt="80px" />
        </Flex>

        <Text textAlign="left" p="20px 0 32px 0" maxW={{base: '100%', lg: '90%'}}>
          Have a Question? 
          Check out our <a href="/faqs" alt="FAQ" style={{color: '#099BFF'}}>FAQ</a> as we have a list of common questions answered there for you. 
          If its not a common questions fill out he form below and we’ll be able to get back to you within 24 hours.
        </Text>

        <FormControl id="name" mb="16px">
          <Input
            value={name}
            onChange={handleNameChange}
            className={isValidInputName ? 'input-valid' : 'input-invalid'}
            type='text'
            placeholder='Full Name'
            autoComplete="off"
          />
        </FormControl>

        <FormControl id="email" mb="16px">
          <Input
            value={email}
            onChange={handleEmailChange}
            className={isValidInputEmail ? 'input-valid' : 'input-invalid'}
            type='email'
            placeholder='Email Address'
            autoComplete="off"
          />
        </FormControl>

        <FormControl id="issue" mb="16px">
          <Input
            value={issue}
            onChange={handleIssueChange}
            className={isValidInputIssue ? 'input-valid' : 'input-invalid'}
            type='issue'
            placeholder='Name the issue'
            autoComplete="off"
          />
        </FormControl>

        <FormControl id="message" mb="32px">
          <Textarea
            value={message}
            onChange={handleMessageChange}
            className={isValidInputMessage ? 'input-valid' : 'input-invalid'}
            type='message'
            placeholder='Detailed description'
            autoComplete="off"
          />
        </FormControl>

        <Button isLoading={isLoadingButton} variant="button-lg" disabled={disabledButton} onClick={handleSend}>Send</Button>

        <Box mt="16px" minH="100px">
          { errorCard && ( <ErrorCard error={errorCard} maxW="100%" /> )}
          { successCard && ( <SuccessCard success={successCard} maxW="100%" /> )}
        </Box>
      </Box>

      <Box position="relative" display={{base: 'none', md: 'block'}}>
        <Image src={glow} alt="Support" />
        <Box className="abstract-grad" top="50%" left="50%" transform="translate(-50%, -50%) scale(1.5)" />
      </Box>
    </Grid>
  );
};

export default SupportForm;